import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { RiCodeLine } from '@remixicon/react';
import { rootRouteRef } from './routes';

export const codespacesPage = PageBlueprint.make({
  params: {
    path: '/github-codespaces',
    routeRef: rootRouteRef,
    loader: () => import('./components/CodespacesPage').then(m => <m.CodespacesPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'github-codespaces',
  title: 'Codespaces',
  icon: <RiCodeLine />,
  extensions: [codespacesPage],
  routes: {
    root: rootRouteRef,
  },
});
